/* global axios */
import ApiClient from './ApiClient';

class CortexProviderConnectionsAPI extends ApiClient {
  constructor() {
    super('cortex/provider_connections', { accountScoped: true });
  }

  createCredential(connectionId, providerCredential) {
    return axios.post(`${this.url}/${connectionId}/provider_credentials`, {
      provider_credential: providerCredential,
    });
  }

  updateCredential(connectionId, credentialId, providerCredential) {
    return axios.patch(
      `${this.url}/${connectionId}/provider_credentials/${credentialId}`,
      { provider_credential: providerCredential }
    );
  }

  deleteCredential(connectionId, credentialId) {
    return axios.delete(
      `${this.url}/${connectionId}/provider_credentials/${credentialId}`
    );
  }

  test(connectionId) {
    return axios.post(`${this.url}/${connectionId}/test`);
  }

  listPlatformConnections() {
    return axios.get(this.platformConnectionAdoptionsUrl);
  }

  adoptPlatformConnection(platformProviderConnectionId) {
    return axios.post(this.platformConnectionAdoptionsUrl, {
      platform_provider_connection_adoption: {
        platform_provider_connection_id: platformProviderConnectionId,
      },
    });
  }

  removePlatformConnection(platformProviderConnectionId) {
    return axios.delete(
      `${this.platformConnectionAdoptionsUrl}/${platformProviderConnectionId}`
    );
  }

  get platformConnectionAdoptionsUrl() {
    return `${this.baseUrl()}/cortex/platform_provider_connection_adoptions`;
  }
}

export default new CortexProviderConnectionsAPI();
